import { GET_HUB_LAST_VISITED_QUERY } from './use-hub-last-visited';
import { gql, useMutation } from '@apollo/client';
import { MarkHubViewedMutation, MarkHubViewedMutationVariables } from '@/types';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useCallback } from 'react';
import { useUnseenAlerts } from './use-unseen-alerts';

export const MARK_HUB_AS_VIEWED_MUTATION = gql`
  mutation MarkHubViewed {
    updateHubLastVisited {
      success
    }
  }
`;

export const useMarkHubAsViewed = () => {
  const { user } = useAuthenticatedUserContext();
  const { refetchUnseenAlerts } = useUnseenAlerts();

  // optimistic update of hub last visited, and retriggers last viewed
  const [markHubAsViewed] = useMutation<
    MarkHubViewedMutation,
    MarkHubViewedMutationVariables
  >(MARK_HUB_AS_VIEWED_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GET_HUB_LAST_VISITED_QUERY,
        variables: { employeeUUID: user.uuid },
      },
    ],
  });

  const markHubViewed = useCallback(async () => {
    // call mutation to mark hub as viewed
    await markHubAsViewed();
    // refetch unseen alerts
    void refetchUnseenAlerts();
  }, [markHubAsViewed, refetchUnseenAlerts]);

  return {
    markHubViewed,
  };
};
